import { createAction, props } from '@ngrx/store';
import {ManageUserPayload, UpdateUserResponse} from '../../../services/api/users/user.model';

export const userUpdate = createAction(
  '[UserUpdate] User Update',
  props<{ id: number, data: ManageUserPayload }>()
);

export const userUpdateSuccess = createAction(
  '[UserUpdate] User Update Success',
  props<{ data: UpdateUserResponse }>()
);

export const userUpdateFailure = createAction(
  '[UserUpdate] User Update Failure',
  props<{ error: unknown }>()
);

export const clearUserUpdateState = createAction(
  '[UserUpdate] clear User Update State',
);
